import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, Observable } from 'rxjs';
import { ConfigurationService } from '../configuration.service';
import { LabpartnerService } from '../labpartner.service';

@Injectable({
  providedIn: 'root',
})
export class ICLUTFileService {
  private v1ICLUTFileServiceURL = 'v1/ICLUTFile';

  private apiUrlBase: string;

  constructor(
    private labpartnerService: LabpartnerService,
    private httpClient: HttpClient,
    configService: ConfigurationService,
  ) {
    const config = configService.getConfig();

    this.apiUrlBase = config.apiServiceEndpoint;
    if (!this.apiUrlBase.endsWith('/')) {
      this.apiUrlBase = `${this.apiUrlBase}/`;
    }
  }

  // Experiment functions
  public getLUTFiles(): Observable<string[]> {
    this.labpartnerService.setIsLoading(true);
    const url = `${this.apiUrlBase}${this.v1ICLUTFileServiceURL}/GetAll`;
    return this.httpClient
      .get<string[]>(url)
      .pipe(finalize(() => this.labpartnerService.setIsLoading(false)));
  }
}
